import { render, staticRenderFns } from "./frame-title-font.vue?vue&type=template&id=e3fd69d8&scoped=true"
import script from "./frame-title-font.vue?vue&type=script&lang=js"
export * from "./frame-title-font.vue?vue&type=script&lang=js"
import style0 from "./frame-title-font.vue?vue&type=style&index=0&id=e3fd69d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fd69d8",
  null
  
)

export default component.exports